
import Vue from "vue";
import {BIconEnvelopeFill} from "bootstrap-vue";
import {EmailLinkLogic} from "./EmailLinkLogic";

export default Vue.extend({
  name: "EmailLink",
  components: {
    BIconEnvelopeFill,
  },
  methods: {
    getValue() {
      return EmailLinkLogic.getAddress(this.$config.domain);
    },
    getHref() {
      return EmailLinkLogic.getHref(this.$config.domain);
    },
  },
});
